import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Hidden, withStyles } from '@material-ui/core'
import Mobile from './Mobile'
import DesktopForm from './DesktopForm'
import {
	receiveCampaign,
	ingestPrediction,
	expandFunnelStage,
} from 'actions/campaign/addOrEdit'
import { list, read } from 'actions/data'
import { getAllGroups } from 'actions/contacts/groups'
import { getContactsWithEmails, getCustomAttributes } from 'actions/contacts'
import { listTasks, listTaskTypes, readTask } from 'actions/tasks'
import { listSignupForm } from 'actions/signupForm'
// import { DndProvider } from 'react-dnd'
// import HTML5Backend from 'react-dnd-html5-backend'
// import TouchBackend from 'react-dnd-touch-backend'
// import MultiBackend, {
//   TouchTransition,
//   MouseTransition,
// } from 'react-dnd-multi-backend'
import TaskModal from './TaskModal'
import Preview from './Preview'
import ContactsModal from './ContactsModal'
import { consumePrediction } from 'actions/predictions'
import { listTemplates } from '../../actions/template'
import Stepper from './Stepper'
import { stepperGoTo } from 'actions/view'
import { DATA_API_URL } from 'utils/AllURLs'

// const CustomHTML5toTouch = {
//   backends: [
//     {
//       backend: HTML5Backend,
//       transition: MouseTransition,
//       // preview: true,
//       // by default, will dispatch a duplicate `mousedown` event when this backend is activated
//     },
//     {
//       backend: TouchBackend,
//       // Note that you can call your backends with options
//       options: { enableMouseEvents: true },
//       preview: true,
//       transition: TouchTransition,
//     },
//   ],
// }

export default connect(
	(state, { match }) => {
		const campaign =
			(state.data.campaign && state.data.campaign[match.params.campaignID]) ||
			null

		return {
      campaign,
      allTaskIDs: [
        ...((campaign && campaign.calendar) || []),
        ...(campaign && campaign.stages
          ? campaign.stages.reduce((acc, el) => {
              if (el.tasks) {
                acc = [...acc, ...el.tasks]
              }
              return acc
            }, [])
          : []),
      ],
      campaignID: match.params.campaignID,
      // campaignsLoaded: state.loadStatus.campaigns,
      eventgoaloptionsLoaded: state.loadStatus.eventgoaloptions,
      // groupsLoaded: state.loadStatus.groups,
      // tasksLoaded: state.loadStatus.tasks,
      // formsLoaded: state.loadStatus.forms,
      taskTypesLoaded: state.loadStatus.taskTypes,
      // templateLoadStatus: state.loadStatus.templates,
      // contactLoadStatus: state.loadStatus.contacts,
      createACampaign: state.predictions.createACampaign
        ? state.predictions.createACampaign
        : null,
      // customformsLoaded: Boolean(Object.keys(state.data?.customform || {}).length),
      a2p10dlcLoadStatus: state.loadStatus.a2p10dlc,
    }
	},
	(dispatch) =>
		bindActionCreators(
			{
				receiveCampaign,
				list,
				getAllGroups,
				getContactsWithEmails,
				listTasks,
				listSignupForm,
				listTaskTypes,
				read,
				consumePrediction,
				ingestPrediction,
				stepperGoTo,
				listTemplates,
				readTask,
				expandFunnelStage,
				getCustomAttributes,
			},
			dispatch,
		),
)(
	withStyles((theme) => ({
		// ...other styles for the pages
		content: {
			padding: '84px 24px 24px',
			// [theme.breakpoints.down('sm')]: {
			//   // padding: maybe something else for 'sm' size,
			// },
			[theme.breakpoints.down('xs')]: {
				padding: 0,
			},
		},
		buttonsStyle: {
			[theme.breakpoints.down('xs')]: {
				width: '100%',
				left: 0,
				top: 56,
			},
			width: 'calc(100% - 80px)',
			position: 'fixed',
			left: '80px',
			// bottom: '0px',
			top: 64,
			padding: '12px',
			background: 'white',
			boxShadow: '0px 5px 5px #00000040',
			zIndex: 1,
		},
	}))(
		class AddOrEditCampaignPage extends Component {
			componentDidMount() {
				const {
					receiveCampaign,
					campaignID,
					campaign,
					read,
					stepperGoTo,
					readTask,
					allTaskIDs,
				} = this.props
				// console.log(new AJV({ verbose: true, allErrors: true }))
				if (campaignID === 'new') {
					receiveCampaign(null)
					stepperGoTo(0, 'campaign')
				} else {
					// stepperGoTo(1, 'campaign')
					const readCampaign = () =>
						read(campaignID, 'campaign')
							.then((campaign) => receiveCampaign(campaign))
							.then(() => {
								console.log('allTaskIDs:')
								console.log(allTaskIDs)

								if (allTaskIDs.length) {
									allTaskIDs.forEach((taskID) =>
										readTask(taskID).then(() =>
											console.log(`read task with id ${taskID}`),
										),
									)
								}
							})

					if (campaign) {
						Promise.resolve(receiveCampaign(campaign)).then(() =>
							readCampaign(),
						)
					} else {
						readCampaign()
					}
				}
				if (!this.props.eventgoaloptionsLoaded) {
					this.props.list('eventgoaloption')
				}

				this.props.list('customform')
				this.props.getCustomAttributes()

				// if (!this.props.groupsLoaded) {
				this.props.getAllGroups()
				// }
				// if (!this.props.tasksLoaded) {
				this.props.listTasks()
				// }
				// if (!this.props.formsLoaded) {
				this.props.listSignupForm()
				// }
				if (!this.props.taskTypesLoaded) {
					this.props.listTaskTypes()
				}
				// if (!this.props.campaignLoadStatus) {
				this.props.list('campaign')
				// }
				// if (!this.props.templateLoadStatus) {
				this.props.listTemplates()
				// }
				// if (!this.props.contactLoadStatus) {
				this.props.getContactsWithEmails()

        this.props.list('phonenumbers')
        
        this.props.list('user', 'user_name') // does this even work?
				// }
				if (!this.props.a2p10dlcLoadStatus) {
					this.props.list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
				}

				this.handlePrediction()
			}

			componentDidUpdate(prevProps) {
				if (
					prevProps.allTaskIDs.length !== this.props.allTaskIDs.length &&
					this.props.allTaskIDs.length
				) {
					this.props.allTaskIDs.forEach((taskID) =>
						this.props
							.readTask(taskID)
							.then(() => console.log(`read task with id ${taskID}`)),
					)
				}
			}

			componentWillUnmount() {
				this.props.stepperGoTo(0, 'campaign')
				this.props.expandFunnelStage(null)
				this.props.receiveCampaign(null)
			}

			handlePrediction = () => {
				const { ingestPrediction, createACampaign, consumePrediction } =
					this.props
				if (createACampaign && createACampaign.entities.length) {
					Promise.resolve(ingestPrediction(createACampaign.entities)).then(() =>
						consumePrediction('createACampaign'),
					)
				}
			}

			render() {
				const { match, classes } = this.props

				return (
					<div
						className={classes.content}
						style={{ height: '100%', maxWidth: '1600px', margin: '0 auto' }}
					>
						<>
							<Stepper />
							<Hidden mdUp>
								<Mobile campaignID={match.params.campaignID} />
							</Hidden>
							<Hidden smDown>
								<DesktopForm campaignID={match.params.campaignID} />
							</Hidden>
							<TaskModal />
							<ContactsModal />
							<Preview />
						</>
					</div>
				)
			}
		},
	),
)
